<template>
  <div class="dropdown" :class="{show: state}">
    <a @click.prevent="toggleDropdown" class="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <slot name="header"></slot>
    </a>

    <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown" v-bind:class="{ show: state }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "dropdown",
  data() {
    return {
      state: false,
    };
  },
  methods: {
    toggleDropdown() {
      this.state = !this.state;
    },
    close(e) {
      if (!this.$el.contains(e.target)) {
        this.state = false;
      }
    },
  },
  watch:{
    $route (){
        this.state = false;
    }
  },
  mounted() {
    document.addEventListener("click", this.close);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.close);
  },
};
</script>